import {
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@roger/ui-components';
import { Settings } from 'lucide-react';

import type { ReportPopulationState } from './reportPopulation';

export function ReportPopulationControls({
  includeTestRows,
  includeInactiveEpisodes,
  onIncludeTestRowsChange,
  onIncludeInactiveEpisodesChange,
  description = 'Choose which rows to include in this report.',
}: ReportPopulationState & {
  onIncludeTestRowsChange: (checked: boolean) => void;
  onIncludeInactiveEpisodesChange: (checked: boolean) => void;
  description?: string;
}) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          type='button'
          variant='outline'
          size='sm'
          aria-label='Report population settings'
        >
          <Settings className='h-4 w-4' aria-hidden='true' />
          <span className='sr-only'>Report population settings</span>
        </Button>
      </DialogTrigger>
      <DialogContent className='w-[calc(100%-2rem)] sm:max-w-md'>
        <DialogHeader>
          <DialogTitle>Report population settings</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className='space-y-3'>
          <label className='flex items-center gap-2 text-sm font-medium'>
            <Checkbox
              checked={includeTestRows}
              onCheckedChange={checked =>
                onIncludeTestRowsChange(checked === true)
              }
            />
            Include test rows
          </label>
          <label className='flex items-center gap-2 text-sm font-medium'>
            <Checkbox
              checked={includeInactiveEpisodes}
              onCheckedChange={checked =>
                onIncludeInactiveEpisodesChange(checked === true)
              }
            />
            Include inactive episodes
          </label>
        </div>
      </DialogContent>
    </Dialog>
  );
}
